var React = require("react"),
  ReactDOM = require("react-dom");
import Footer2 from "./components/Landing/FooterLanding.component";

var FooterContent = React.createClass({
  render: function() {
    let isLandingPagePro = PAGE_OPTIONS.isLandingPagePro;
    if (isLandingPagePro) {
      return (
        <div className="">
          <Footer2 />
        </div>
      );
    } else {
      return (
        <div className="hidden-xs">
          <Footer2 />
        </div>
      );
    }
  }
});

ReactDOM.render(<FooterContent />, document.getElementById("containerFooter"));



// WEBPACK FOOTER //
// ./assets/react/footer.jsx